import $ from 'jquery';
import { LuminousGallery } from 'luminous-lightbox';

export default class Gallery {
    constructor(e) {
        this.$e = $(e);
        this.$queue = this.$e.find('.g__queue');
        this.options = {
            showCloseButton: true,
        };
        if (this.$queue.length) this.init();
    }

    init() {
        this.gallery = new LuminousGallery(this.$e[0].querySelectorAll('.g__1 .lb, .g__6 .lb, .g__12 .lb, .g__21 .lb'), this.options);
        this.change();
        this.setInterval();
    }
    setInterval() {
        this.interval = setInterval(() => {
            this.change();
        }, 10000);
    }
    change() {
        const imgs = this.$e.find('.g__wrapper .lb').toArray();
        const replace = [];
        const max = Math.min(this.$queue.children().length, 3);
        for (let i = 0; i < max; i++) {
            let index = Math.floor(Math.random() * imgs.length);
            replace.push(imgs.splice(index, 1));
        }
        replace.forEach(e => {
            const $e = $(e);
            let $img = this.$queue.children().first();
            if ($img[0].tagName === 'DIV') {
                // $lb = $(`<a href="${$lb.attr('data-src')}" class="lb"><img src="${$lb.attr('data-src')}" srcset="${$lb.attr('data-srcset')}" sizes="${$lb.attr('data-sizes')}" alt="${$lb.attr('data-alt')}"></a>`);
                $img = $(`<img data-src="${$img.attr('data-href')}" src="${$img.attr('data-src')}" alt="${$img.attr('data-alt')}">`);
                this.$queue.children().first().remove();
            }
            $img.addClass('flipIn');
            $e.find('img').addClass('flipOut');
            // $lb.insertAfter($e)
            $img.appendTo($e);
            $img.parent().attr('href', $img.attr('data-src'));
            setTimeout(() => {
                $e.find('img').first().removeClass('flipOut').appendTo(this.$queue);
                $img.removeClass('flipIn');
            }, 1000);
        });
        this.gallery.destroy();
        this.gallery = new LuminousGallery(this.$e[0].querySelectorAll('.g__1 .lb, .g__6 .lb, .g__12 .lb, .g__21 .lb'), this.options);
        this.$e.find('.lb').off('click.g').on('click.g', () => {
            this.open();
            this.bindClose();
        });
    }
    open() {
        clearInterval(this.interval);
        this.interval = false;
    }
    close() {
        if (!this.interval) this.setInterval();
    }
    bindClose() {
        $('.lum-lightbox, .lum-close-button').off('click.g').on('click.g', () => {
            this.close();
        });
        $(document).off('keyup.g').on('keyup.g', (e)=>{
            if (e.key === "Escape") {
                this.close();
            }
        });
    }
}